import styled from "styled-components"
import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AccountCircle from '@mui/icons-material/AccountCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FlagIcon from '@mui/icons-material/Flag';
import { solicitudesCompraSelected,solicitudescompraEstado } from "../../../redux/actions/solicitudCompraActions.js";
import { useDispatch, useSelector } from "react-redux" ;
import api from '../../../axios.js';

const Container=styled.div`
	height:100%;
	width:100%;
	display:flex;
	justify-content:space-around;
	background-color:#1F1E1E;
	border-radius:10px;
	position:relative;
	overflow:hidden

`;

const ContainerOverlay=styled.div`
	position:absolute;
	width:100%;
	height:100%;
	display:flex;
`;

const Overlay=styled.div`
	height:100%;
	width:97%;
	z-index:0;
	background-size:cover;
	background-position:center;
	background-repeat:no-repeat;
	opacity:0
`;

const ContainerCompra=styled.div`
	display:flex;
	
	justify-content:space-around;
	width:99%;
	height:100%;
	font-size:13px;
 	text-align:center
`;

const ContainerUsuario=styled.div`
	display:flex;
	justify-content:space-around;
	align-items:center;
	font-weight:bold;
	font-size:18px;
	z-index:1
`;

const ContainerFechaSolicita=styled.div`
	display:flex;
	justify-content:center;
	align-items:center;
	flex-direction:column;
	
	z-index:1
`;

const Containerdetalle=styled.div`
	display:flex;
	justify-content:center;

`;

const ContainerdetalleDivicion=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:center;
	margin:10px;
	z-index:1

`;

const ContainerDesicion=styled.div`

	z-index:1
`;

const ContainerAceptada=styled.div`
	width:25px;
	height:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	writing-mode: vertical-lr;
	background-color:#032C01;
	border-radius:0px 15px 15px 0px;
	z-index:1
    
`;

const ContainerRechazada=styled.div`
	width:25px;
	height:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	writing-mode: vertical-lr;
	background-color:#470707;
	border-radius:0px 15px 15px 0px;
	z-index:1
    
`;
const Accept=styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	border-radius:0px 10px 0px 0px;
	background-color:#032C01;
	height:50%;
`;

const Decline=styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	border-radius:0px 0px 10px 0px;
	background-color:#470707;
	height:50%;
`;




export default function RowSolicitudCompra(props){
	let { compra,openBackdrop } = props;
	let pais=compra.pais;
	let dispatch=useDispatch();
	let compraSelected=useSelector(state=>state.solicitudCompras.solicitudCompraSelected);
	let moneda={simbolo:"$",ISO:"USD"};

	switch(compra.pais){
 	case "peru":
 		moneda={simbolo:"S/",ISO:"PEN"}
 		break
 	case "bolivia":
 		moneda={simbolo:"$",ISO:"BOB"}
 		break
 	case "argentina":
 		moneda={simbolo:"S/",ISO:"ARS"}
 		break
 	case "mexico":
 		moneda={simbolo:"$",ISO:"MXN"}
 		break
 	case "colombia":
 		moneda={simbolo:"$",ISO:"COP"}
 		break
 	case "chile":
 		moneda={simbolo:"$",ISO:"CLP"}
 		break
 	case "uruguay":
 		moneda={simbolo:"$",ISO:"UYU"};
 		break
 	default:
 		moneda={simbolo:"$",ISO:"USD"};
 	}


	let total=compra.Reventa.reduce((acu,reventa)=>acu+reventa[`precio_${pais}`],0 );


	let handleClick=()=>{
		openBackdrop({compra:compra,state:true});
		dispatch(solicitudesCompraSelected(compra.id))
	};



	let aceptar=async(e)=>{
		e.stopPropagation()
 		dispatch(solicitudescompraEstado(1)); 		
 		if(window.confirm( `desea ACEPTAR la solicitud de ${compra.Users[0].name} con id ${compra.id}`)){
 			try{
 				await api.post(`/solicitudCompra/accept?id=${compra.id}`);	
 				alert("solicitud aceptada");	
 				dispatch(solicitudescompraEstado(0));

 			}catch(err){ console.error(err);alert(err.response.data) };
 		};
 		dispatch(solicitudescompraEstado(0)); 

 	}

 	let rechazar=async(e)=>{
 		e.stopPropagation()
 		dispatch(solicitudescompraEstado(1));
 		if(window.confirm( `desea RECHAZAR la solicitud de ${compra.Users[0].name}con id ${compra.id}`)){
 			try{
 				await api.post(`/solicitudCompra/refuse?id=${compra.id}`);
 				alert("solicitud rechazada");
 				dispatch(solicitudescompraEstado(0));
 			}catch(err) {console.error(err);alert(err.response.data)};
 			

 		};
 		dispatch(solicitudescompraEstado(0));
 	};

	return(
		<Container onClick={handleClick} style={{border:compraSelected===compra.id?"2px solid yellow":"none"}}>
			<ContainerCompra>
				<ContainerOverlay>
					{compra.Reventa.map(reventa=><Overlay style={{backgroundImage:`url(${reventa.Juego.poster})`}}/>)}
				</ContainerOverlay>
				<ContainerUsuario>
					<AccountCircle style={{ fontSize: 40,marginRight:"15px"}}/>
					<div> {compra.Users[0].name} ({compra.Users[0].usuario}) </div>
				</ContainerUsuario>
				<ContainerFechaSolicita>
					<CalendarMonthIcon style={{ fontSize: 25}}/> 
					{compra.aceptada?<div style={{color:"green"}}>Aceptado : {new Date(compra.updatedAt).toLocaleDateString()}</div>:
						compra.rechazada?<div style={{color:"red"}}>Rechazada : {new Date(compra.updatedAt).toLocaleDateString()}</div>:
						<div>solicitado : {new Date(compra.createdAt).toLocaleDateString()}</div>}
				</ContainerFechaSolicita>
				<Containerdetalle>
					<ContainerdetalleDivicion>
						<div><FlagIcon style={{ fontSize: 15,marginRight:"5px"}}/> Pais :    {compra.Users[0].pais} </div>				
						<div style={{fontSize:"15px"}}><b>N° reventas solicita : {compra.Reventa.length}</b></div>	
					</ContainerdetalleDivicion>
					<ContainerdetalleDivicion>
						<div>tipo precio :  {pais}</div>
						<div>total : {moneda.simbolo} {total} {moneda.ISO}</div>
					</ContainerdetalleDivicion>					
				</Containerdetalle>
				
				
					
			</ContainerCompra>
			{compra.aceptada?<ContainerAceptada><b>Aceptada</b></ContainerAceptada>:compra.rechazada===true?<ContainerRechazada><b>Rechazada</b></ContainerRechazada>:
			<ContainerDesicion>
 				<Accept  onClick={aceptar}> <CheckIcon  style={{color:"green"}} /></Accept>
 				<Decline onClick={rechazar}> <DeleteOutlineIcon style={{color:"#BB0E0E"}}/> </Decline>
 			</ContainerDesicion>}
		</Container>
	)
}